import.meta.glob([
  '../images/**',
]);

import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/collapse';
import './seo-form';
/*
import './bootstrap';
import * as bootstrap from 'bootstrap';
*/


document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[href^="#"], [data-scroll]');
    if (!trigger) return;

    const targetId = trigger.getAttribute('href') || trigger.dataset.scroll;
    if (!targetId || targetId === '#') return;

    const target = document.querySelector(targetId);
    if (!target) return;

    e.preventDefault();

    const offset = 80; // adjust if you have fixed navbar
    const position = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
        top: position,
        behavior: 'smooth'
    });
});